import { collection, doc, setDoc, serverTimestamp } from "firebase/firestore";

import { PhoneNumber } from "@/models/shared";
import { currentTimeInSeconds } from "@/utils/common";
import { Collections } from "@/constants/firebase.collections";

import { setLogDoc } from "../logs";
import { db } from "..";

// Emails Collection Ref
const emailsRef = collection(db, Collections.EMAILS);

export const createEmail = async (phoneNumber: PhoneNumber, email: string) => {
  setLogDoc(phoneNumber, {
    type: "submitted_email",
    timestamp: currentTimeInSeconds(),
  });

  const docRef = doc(emailsRef);
  await setDoc(docRef, {
    email,
    phone_number: phoneNumber,
    timestamp: currentTimeInSeconds(),
    created_at: serverTimestamp(),
  });
};
